import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IOrderDetailsModel } from '@apps-common/types/portal/order'

export const QUERY_GET_ORDER_DETAILS = (id: string) => ['getOrderDetails', id]

export const getOrderDetails = async (id: string): Promise<IOrderDetailsModel> =>
  axios.get(`/order/order?orderId=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getOrderDetails

type Props = {
  config?: QueryConfig<QueryFnType>
  id: string
}

export const useGetOrderDetails = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_ORDER_DETAILS(id),
    queryFn: () => getOrderDetails(id)
  })
